import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardConstants } from './dashboard.const';

import { DashboardComponent } from './dashboard.component';
import { MainBoardComponent } from './components/main-board/main-board.component';
import { AttendanceComponent } from './components/attendance/attendance.component';
import { MaindashboardComponent } from './components/maindashboard/maindashboard.component';

import { AuthGuardService } from '../../shared/services/auth-guard.service';
import { ProjectsService } from '../work/services/projects.service';

import { workRoutes } from '../work/work.routes';
import { issuesRoutes } from '../issues/issues.routes'; 

// Route Configuration
export const dashboardRoutes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    children: [
      {
        path: 'sprintboard',
        component: MainBoardComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'attendance',
        component: AttendanceComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'maindashboard',
        component: MaindashboardComponent,
        canActivate: [AuthGuardService]
      }
    ]
  }
];

export const dashboardRoutingProviders: any[] = [
  ProjectsService
];


// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.routes.ts